import { Box, Button, Typography } from '@material-ui/core';
import useGetViewPortDimensions from 'hooks/useGetViewPortDimensions';
import React from 'react';
import { NavLink } from 'react-router-dom';
import useStyles from '../Styles';

const WaterUserCard = (props) => {
    const classes = useStyles();
    const { title, image, desc, route } = props;
    const { isMobile } = useGetViewPortDimensions();

    const style = {
        backgroundImage: `url(${image})`,
        backgroundSize: isMobile ? 'auto' : 'auto 100%',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '50% 50%',
    }
    
    return (
        <Box className={classes.waterUserCard} style={style}>
            <NavLink to={route} style={{ textDecoration: 'none' }}>
                <Box className={classes.waterUserOverlay}>
                    <Typography variant='h4' component="div" className={classes.waterUserCardTitle}>{title}</Typography>
                    <Typography variant='body2' component="div" className={classes.waterUserDesc}>{desc}</Typography>
                    <Button variant='contained' className={classes.waterUserExploreBtn}>Explore</Button>
                </Box>
            </NavLink>
        </Box>
    );
};

export default WaterUserCard;